module.exports = __webpack_public_path__ + "static/media/video-cinematic.e4169305.png";